// Gera e baixa um CSV no navegador. Usa ";" como separador e BOM UTF-8 para o Excel
// em pt-BR abrir acentos e colunas corretamente sem assistente de importação.
function escapeCell(cell: string | number): string {
  const text = String(cell);
  return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function slugify(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function downloadCsv(filename: string, headers: string[], rows: (string | number)[][]) {
  const lines = [headers, ...rows].map((row) => row.map(escapeCell).join(';'));
  const blob = new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${slugify(filename)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
